'use strict';

var groupConfigCtrl = ['$uibModal', function ($uibModal) {
    var _this = this;

    _this.openConfig = function () {      
        var options = {
            animation: true,
            controller: require("../dinamic-group-config/dinamicGroupConfig"),
            templateUrl: 'dashboard-builder/dinamic-group-config/dinamicGroupConfig.html',
            controllerAs: 'ctrl',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true,
            backdrop: 'static',
            resolve: {
                element: function () {
                    return _this.element;
                },
                isForValidator: function () {
                    return _this.isForValidator;
                }
            }
        };
        $uibModal.open(options);
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            isForValidator:'='
        },
        replace: true,
        controller: groupConfigCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/group-element/groupOptions.html'
    };
};